import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //CIBottlerSelection REDUX part
  CIbottlerData: [],
  CItransformedTreeData: [],
  CIselectedTreeIds: [],
  CIfinalTreeData: [],
  CIfilterApplied: false,
};

const CIEntityTree = createSlice({
  name: "CIentity",
  initialState,
  reducers: {
    setCIBottlerData: (state, action) => {
      state.CIbottlerData = action.payload;
    },
    setCITransformedTreeData: (state, action) => {
      state.CItransformedTreeData = action.payload;
    },
    setCISelectedTreeIds: (state, action) => {
      state.CIselectedTreeIds = action.payload;
    },
    setCIFinalTreeData: (state, action) => {
      state.CIfinalTreeData = action.payload;
    },
    setCIFilterApplied: (state, action) => {
      state.CIfilterApplied = action.payload;
    },
  },
});

export const {
  setCIBottlerData,
  setCITransformedTreeData,
  setCISelectedTreeIds,
  setCIFinalTreeData,
  setCIFilterApplied,
} = CIEntityTree.actions;
export default CIEntityTree.reducer;
